import { ComponentType } from '@angular/cdk/portal';
import { ModalDialogData } from './modal-dialog-data.model';
import { ModalDialogComponent } from './modal-dialog.component';
import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { EMPTY, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModalDialogService {
  constructor(private dialog: MatDialog) {}
  private dialogRef?: MatDialogRef<ModalDialogComponent>;

  public open(dialogConfig: ModalDialogData, config?: MatDialogConfig): void {
    this.dialogRef = this.openComponent(ModalDialogComponent, dialogConfig, config);
  }

  public openComponent<T, D>(component: ComponentType<T>, data: D, config?: MatDialogConfig) : MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {disableClose: true};
    const allConfig: MatDialogConfig = {...defaultConfig, ...config};
    return this.dialog.open(component, {
      data: data,
     ...allConfig
    });
  }

  public confirmed(): Observable<boolean> {
    if (!this.dialogRef) {
      return EMPTY;
    }

    return this.dialogRef.afterClosed().pipe(
      take(1),
      map((res: boolean) => res)
    );
  }
}
